// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".BookingList-wrapper[data-v-5548d0c3]{display:flex;flex-wrap:wrap}.BookingList-booking-item[data-v-5548d0c3]{padding:10px;margin:20px}@media only screen and (max-width:1000px){.BookingList-booking-item[data-v-5548d0c3]{padding:10px;margin:30px;width:calc(100% - 80px)}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
